import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "聊天", -1)
const _hoisted_5 = { class: "right" }

import { useChatStore } from "@/store/chatStore";
import Chat from "@/mode/Chat";
import ChatMessage from "@/views/chat/ChatMessage.vue";
import Top from "@/components/Top.vue";
import ChatItem from "@/components/ChatItem.vue";
import { computed, nextTick, onMounted, ref } from "vue";
import ChatUtils from "@/utils/ChatUtils";
import ChatType from "@/config/ChatType";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const chatStore = useChatStore();
const store = useChatStore();
const show = ref<boolean>(false);
const chat = computed((): Chat => {
  return chatStore.chats[chatStore.index];
});
const showChat = (chat: Chat) => {
  store.openChat(chat);
  nextTick(() => {
    ChatUtils.imageLoad("message-box");
  });
};
const delChat = (id: string) => {
  store.delChat(id);
};
onMounted(() => {
  show.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            })
          ]),
          _: 1
        })
      ]),
      (show.value)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, {
            key: 0,
            class: "list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).chats, (chat, index) => {
                return (_openBlock(), _createBlock(ChatItem, {
                  key: chat.id,
                  index: index,
                  id: chat.id,
                  img: chat.avatar,
                  username: chat.name,
                  unreadCount: chat.unreadCount,
                  text: chat.lastMessage,
                  showDel: true,
                  "is-group": chat.type===_unref(ChatType).GROUP,
                  active: index === _unref(store).index,
                  onDel: delChat,
                  onClick: ($event: any) => (showChat(chat))
                }, null, 8, ["index", "id", "img", "username", "unreadCount", "text", "is-group", "active", "onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Top),
      (chat.value)
        ? (_openBlock(), _createBlock(ChatMessage, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})